namespace RedBullMOBILE360.Administration {
    export enum TwoFactorAuthType {
        Email = 1,
        SMS = 2
    }
    Serenity.Decorators.registerEnumType(TwoFactorAuthType, 'RedBullMOBILE360.Administration.TwoFactorAuthType');
}
